<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">版本信息</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="modelForm"
          :model="modelForm"
          :rules="modelRules"
          label-width="130px"
        >
          <el-form-item label="版本号" prop="version">
            <el-input v-model="modelForm.version" placeholder="请输入版本号" />
          </el-form-item>
          <el-form-item label="充电枪类型" prop="zhuangType">
            <el-radio-group v-model="modelForm.zhuangType">
              <el-radio
                v-for="(item, index) in allStationtype"
                :key="index"
                :label="item.id"
              >{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="充电枪功率" prop="zhuangKw">
            <div class="d-flex">
              <el-input
                v-model="modelForm.zhuangKw"
                placeholder="请输入充电枪功率"
              />
              <div class="ml-20">KW</div>
            </div>
          </el-form-item>
          <el-form-item label="FTP服务器地址" prop="ftpPath">
            <el-input
              v-model="modelForm.ftpPath"
              placeholder="请输入FTP服务器地址"
            />
          </el-form-item>
          <el-form-item label="FTP服务器端口号" prop="ftpPort">
            <el-input
              v-model="modelForm.ftpPort"
              placeholder="请输入FTP服务器端口号"
            />
          </el-form-item>
          <el-form-item label="用户名" prop="userName">
            <el-input v-model="modelForm.userName" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="账户密码" prop="userPassword">
            <el-input
              v-model="modelForm.userPassword"
              placeholder="请输入账户密码"
            />
          </el-form-item>
          <el-form-item label="文件路径" prop="filePath">
            <el-input
              v-model="modelForm.filePath"
              placeholder="请输入文件路径"
            />
          </el-form-item>
          <el-form-item label="下载超时时间" prop="downTimeOut">
            <div class="d-flex">
              <el-input
                v-model="modelForm.downTimeOut"
                placeholder="请输入下载超时时间"
              />
              <div class="ml-20">分钟</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 所有的电桩类型
      allStationtype: [
        {
          name: '交流',
          id: '2'
        },
        {
          name: '直流',
          id: '1'
        }
      ],
      modelForm: {
        id: '',
        version: '',
        zhuangType: '',
        zhuangKw: '',
        ftpPath: '',
        ftpPort: '',
        userName: '',
        userPassword: '',
        filePath: '',
        downTimeOut: ''
      },
      modelRules: {
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        zhuangType: [
          { required: true, message: '请选择充电枪类型', trigger: 'change' }
        ],
        zhuangKw: [
          { required: true, message: '请输入充电枪功率', trigger: 'blur' },
          { pattern: /^(\-|\+)?\d+(\.\d+)?$/, message: '只能输入数字或小数', trigger: 'blur' }
        ],
        ftpPath: [
          { required: true, message: '请输入FTP服务器地址', trigger: 'blur' }
        ],
        ftpPort: [
          { required: true, message: '请输入FTP服务器端口号', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '只能输入数字', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入账户密码', trigger: 'blur' }
        ],
        filePath: [
          { required: true, message: '请输入文件路径', trigger: 'blur' }
        ],
        downTimeOut: [
          { required: true, message: '请输入下载超时时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.id) {
      this.modelForm.id = this.$route.query.id
      this.$store.dispatch('form/handle', {
        url: '/alarm/firmware/detail?id=' + this.modelForm.id,
        method: 'get',
        callback: (resp) => {
          this.modelForm = JSON.parse(JSON.stringify(resp))
        }
      })
    }
  },
  methods: {
    // 点击提交的函数
    onSubmit() {
      let modelFormBool = false
      this.$refs['modelForm'].validate((valid) => {
        modelFormBool = valid
      })

      // 表单的验证通过
      if (modelFormBool) {
        // 进入数据提交函数
        this.submitData()
      }
    },
    submitData() {
      if (this.$route.query.id) {
        this.$store.dispatch('form/handle', {
          url: '/alarm/firmware/update',
          data: this.modelForm,
          method: 'put',
          callback: () => {
            this.$router.go(-1)
          }
        })
      } else {
        this.$store.dispatch('form/handle', {
          url: '/alarm/firmware/add',
          data: this.modelForm,
          method: 'put',
          callback: () => {
            this.$router.go(-1)
          }
        })
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
.d-flex {
  display: flex;
}
.ml-20 {
  margin-left: 20px;
  width: 50px;
}
.flexJCenter {
  display: flex;
  justify-content: center;
}
.mt-25 {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/editVersion.vue